module.exports = __webpack_public_path__ + "static/media/no-access.997be93e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-access.gif
// module id = 387
// module chunks = 0